import { NgModule } from '@angular/core';
import { NgImageAsParticlesComponent } from './ng-image-as-particles.component';



@NgModule({
  declarations: [NgImageAsParticlesComponent],
  imports: [
  ],
  exports: [NgImageAsParticlesComponent]
})
export class NgImageAsParticlesModule { }
